// extracted by mini-css-extract-plugin
export var newsletterForm = "newsletter-form-module--newsletter-form--jyDfj";
export var validationMessage = "newsletter-form-module--validation-message--4SKaz";
export var formGroup = "newsletter-form-module--form-group--3UxvI";
export var error = "newsletter-form-module--error--3Sr93";